module.exports = __webpack_public_path__ + "img/checkin-failed.5841f740.png";